export default "__VITE_ASSET__sZxmRMk3__"